import { DeliveriesModel } from '@w3lcome/types';
import { getDb } from './SqliteDatabase';

// Inicializa a tabela deliveries_table, caso ainda não exista
const init = async () => {
  const db = getDb();
  await db.execAsync(`
    CREATE TABLE IF NOT EXISTS deliveries_table (
      id TEXT PRIMARY KEY,
      delivery TEXT NOT NULL
    );
  `);
};

// Cria um novo registro na tabela
const create = async (delivery: Partial<DeliveriesModel>) => {
  if (!delivery.id) throw new Error('Delivery must have an id');

  const db = getDb();
  const json = JSON.stringify(delivery);

  await db.withTransactionAsync(async (txn) => {
    await txn.executeSqlAsync('INSERT INTO deliveries_table (id, delivery) VALUES (?, ?);', [
      delivery.id,
      json,
    ]);
  });
};

// Remove um registro específico da tabela
const deleteOne = async (id: string) => {
  const db = getDb();
  await db.withTransactionAsync(async (txn) => {
    const result = await txn.executeSqlAsync('DELETE FROM deliveries_table WHERE id = ?;', [id]);

    if (result.rowsAffected === 0) {
      throw new Error(`Delivery with id ${id} not found`);
    }
  });
};

// Retorna todos os registros
const all = async (): Promise<DeliveriesModel[]> => {
  const db = getDb();
  const deliveries: DeliveriesModel[] = [];

  await db.withTransactionAsync(async (txn) => {
    const { rows } = await txn.executeSqlAsync('SELECT * FROM deliveries_table;', []);

    for (let i = 0; i < rows.length; ++i) {
      const item = rows.item(i);
      deliveries.push(JSON.parse(item.delivery));
    }
  });

  return deliveries;
};

// Remove a tabela inteira
const deleteTable = async () => {
  const db = getDb();
  await db.execAsync('DROP TABLE IF EXISTS deliveries_table;');
};

export default {
  init,
  create,
  deleteOne,
  all,
  deleteTable,
};
